import { Component, EventEmitter, Input, NgZone, OnInit } from '@angular/core';
import { CNConsultation, CNConsultationType } from 'src/app/models/cnconsultation';
import { SNItem } from 'src/app/models/snitem';
import { PatientService } from 'src/app/services/patient.service';
import * as moment from 'moment';
import { TypeManager, TypeManagerService } from 'src/app/services/type-manager.service';
import { MatDialog } from '@angular/material/dialog';
import { DrugNotification, DrugNotificationService, DrugNotificationType } from 'src/app/services/drug-notification.service';
import { CNPrescriptionEntry } from 'src/app/models/cnprescriptionentry';
import { ItemAccessDialogComponent } from 'src/app/dialogs/item/item-access-dialog/item-access-dialog.component';
import { BecareConfigService } from 'src/app/services/becare-config.service';
import { BecareService } from 'src/app/services/becare.service';
import { PrescriptionOutputDialogComponent } from 'src/app/dialogs/prescription/prescription-output-dialog/prescription-output-dialog.component';
import { ContactService } from 'src/app/services/contact.service';
import { PrescriptionService } from 'src/app/services/prescription.service';
import { UserOpenItemsService } from 'src/app/services/user-open-items.service';
import { PrintItemDialogComponent } from 'src/app/dialogs/print/print-item-dialog/print-item-dialog.component';
import { ReportDialogComponent } from 'src/app/dialogs/report/report-dialog/report-dialog.component';
import { ODBService } from 'src/app/services/odb.service';

declare var Ext: any;

@Component({
  selector: 'app-contact-row-icons',
  templateUrl: './contact-row-icons.component.html',
  styleUrls: ['./contact-row-icons.component.scss']
})
export class ContactRowIconsComponent implements OnInit {

  public hasExtraIcons = false;
  public isRx = false;

  private theItem: CNConsultation;
  public reportID: number;
//  private drugEmitter: EventEmitter<DrugNotification>;

  constructor(private patient: PatientService, private dialog: MatDialog,
              private notification: DrugNotificationService, private becare: BecareService,
              private ngZone: NgZone, public contactservice: ContactService,
              private odb: ODBService, private userOpenItemsSrv: UserOpenItemsService) { }

  ngOnInit(): void {
  }

  @Input() set item (theItem: CNConsultation) {
    this.theItem = theItem;
    if (this.theItem.getProperty('ReportID') !== null) {
      this.reportID = parseInt(this.theItem.getProperty('ReportID'));
      this.hasExtraIcons = true;
    }
    this.isRx = this.theItem.type === CNConsultationType.RX;
  }

  get item(): CNConsultation {
    return this.theItem;
  }

  editContact() {
    if (this.contactservice.useOld) {
      this.ngZone.runOutsideAngular(() => {
        setTimeout(() => {
          // Open old consultation interface
          const consultationWindow = new Ext.CNConsultationWindow({
            consultationid: this.item.id,
            displayconsult: true,
            displayservicecode: true,
            prestataireid: this.item.healthagentid,
            consultDate: moment(this.item.date).format('DD/MM/YYYY'),
            closewhensaved: true,
            displaybillbutton: false,
            paid: (this.item.getProperty('paid') === 'true') ? true : false,
            source: 'consultationlist'
          });
          consultationWindow.on('close', () => {
            this.ngZone.run(() => {
              this.contactservice.load();
            });
          });
          consultationWindow.show();
        });
      });
    } else {
      // Use new consultation interface
      this.userOpenItemsSrv.addItem(this.item);
      // if (this.typeManager.typeMap('ContactEditDialogComponent')) {
      //   const componentFactory = this.typeManager.typeMap('ContactEditDialogComponent');
      //   const dialogRef = this.dialog.open(componentFactory, {
      //       data: {
      //         contact: this.item
      //       }
      //   });
      //   dialogRef.afterClosed().subscribe(result => {
      //     if (result) {
      //     }
      //   });
      // }
    }
  }

  printContact() {
    const dialogRef = this.dialog.open(PrintItemDialogComponent, {data: this.item});
    dialogRef.afterClosed().subscribe(result => {
    });
  }

  openAccess() {
    const dialogRef = this.dialog.open(ItemAccessDialogComponent, {
      data: {
        item: this.item
      },
      maxWidth: '60%',
      minWidth: '480px'
    });
    dialogRef.afterClosed().subscribe(result => {
    });
  }

  openReport() {
    this.odb.itemById(this.reportID).subscribe(report => {
      const dialogRef = this.dialog.open(ReportDialogComponent, {
        data: {
          report
        }
      });
      
    }).unsubscribe();
  }

  createReport() {
    this.ngZone.runOutsideAngular(() => {
      setTimeout(() => {
        // Open old report interface
        const documentWindow = new Ext.CNDocumentWindow({
          patientid: this.patient.patient.id,
          contactid: this.theItem.id,
          title:'Rapport radiographie'
        });
        documentWindow.on('documentSaved', () => {
          console.log('document saved');
        });
        documentWindow.show();
      });
    });
  }
}
